import script from "./RealTimeData.vue?vue&type=script&setup=true&lang=js"
export * from "./RealTimeData.vue?vue&type=script&setup=true&lang=js"

import "./RealTimeData.vue?vue&type=style&index=0&id=0dc1eda7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc1eda7"]])

export default __exports__